import React from 'react';
import { Link } from 'gatsby';
import ContainerWAside from 'shared/container-w-aside';
import InfluencerCard from 'shared/person-card';
import Img from 'img';

import styles from './article_intro_1.module.scss';

function ArticleIntro1({
  title,
  image,
  person_card,
  description,
  defaultAsideProps,
  custom_asides,
  asides_list
}) {
  return (
    <ContainerWAside {...{ title, defaultAsideProps, custom_asides, asides_list }}>
      <Link to={['/influencers', person_card.username].join('/')} className={styles.contentWrapper}>
        <Img src={image || 'placeholder-dark'} className={styles.img} />
        <div className={styles.cardWrapper}>
          <InfluencerCard {...person_card} />
        </div>
        <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
      </Link>
    </ContainerWAside>
  );
}
export default ArticleIntro1;
